"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var module_1 = require("./module");
exports.TopicContext = react_1.createContext({ name: "" });
exports.Topic = function (_a) {
    var children = _a.children, name = _a.name;
    var _b = react_1.useContext(module_1.ModuleContext), modCtx = _b[0], _ = _b[1];
    var c = react_1.default.Children.map(children, function (child) {
        if (child.type.displayName === "AnimationGroup") {
            return react_1.cloneElement(child, { active: modCtx.currentInteraction });
        }
        return child;
    });
    return react_1.default.createElement(exports.TopicContext.Provider, { value: { name: name } }, c);
};
exports.Topic.displayName = "Topic";
